import * as types from './types'
import * as baseMethods from '../utils/baseMethod'

const mutations = {
  [types.GET_MEMBERINFO](state, obj) {
    baseMethods.setLocalObj('memberInfo', obj)
    state.memberInfo = obj
  },
  [types.GET_COURSEINFO](state, obj) {
    baseMethods.setLocalObj('courseInfo', obj)
    state.courseInfo = obj
  },
  [types.GET_SERVICE_AGREEMENT_STATUS](state, { status }) {
    state.isShowServiceAgreement = status
  },
  setKeepAlive (state, obj) {
    state.keepAlive = obj
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js